'use client'

import { startBugsnag } from '@/utils/bugsnag';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

const queryClient = new QueryClient()

startBugsnag()
 
interface AppProps {
  children: React.ReactNode
}

export default function App({ children }: AppProps) {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}